// extracted by mini-css-extract-plugin
export default {"etfResearchContainer":"Snapshot_etfResearchContainer__e6O5D"};